"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";
import { Chip, Flex, Heading, Text, useFormattedDate } from "@huub-web/ui";

export interface AnalysisHeadingTemplateProps {
  generatedAt?: string;
  title?: string;
  description?: string;
}

/**
 * @deprecated
 */
export const AnalysisHeadingTemplate: FC<
  AnalysisHeadingTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ generatedAt, title, description, ref }) => {
  const { t } = useTranslation();
  const { formatDate } = useFormattedDate();

  return (
    <Flex ref={ref} direction="column" gap="s">
      <Heading
        variant="main"
        title={title ?? t("analysisHeading.title")}
        description={description ?? t("analysisHeading.description")}
      />

      {generatedAt && (
        <Flex gap="xxs" align="center" direction="column">
          <Chip variant="tertiary" size="l">
            <Text variant="bodyM" color="currentColor50" as="span">
              {t("analysisHeading.analyzedOn")}
            </Text>
            {formatDate(generatedAt, { format: "dayMonthYear" })}
            <Text variant="bodyM" color="currentColor50" as="span">
              {t("analysisHeading.at")}
            </Text>
            {formatDate(generatedAt, { format: "minutesHours" })}
          </Chip>
        </Flex>
      )}
    </Flex>
  );
};
